export class DocumentType {

  public id: string;
  public type: string;

}
